// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./sass/detail/buttons.scss
// module id = 90
// module chunks = 0